var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-table',{attrs:{"columns":_vm.columns,"elements":_vm.tickets,"can-update":false,"can-delete":false,"can-search":false,"is-loading":_vm.isLoading,"custom-buttons":[
    {
      variant: 'primary',
      icon: 'eye',
      event: 'openTicket',
    } ]},on:{"openTicket":_vm.openTicket}})}
var staticRenderFns = []

export { render, staticRenderFns }